var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21_3297",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 90,
    height: 90
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21_3297)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 75C42 72.625 38.75 70.7812 35.25 69.4688C31.75 68.1562 28.125 67.5 24.375 67.5C21.75 67.5 19.1719 67.8438 16.6406 68.5312C14.1094 69.2188 11.6875 70.1875 9.375 71.4375C8.0625 72.125 6.79688 72.0938 5.57812 71.3438C4.35938 70.5938 3.75 69.5 3.75 68.0625V22.875C3.75 22.1875 3.92188 21.5313 4.26562 20.9063C4.60938 20.2813 5.125 19.8125 5.8125 19.5C8.6875 18 11.6875 16.875 14.8125 16.125C17.9375 15.375 21.125 15 24.375 15C28 15 31.5469 15.4688 35.0156 16.4062C38.4844 17.3438 41.8125 18.75 45 20.625V66C48.1875 64 51.5312 62.5 55.0312 61.5C58.5312 60.5 62.0625 60 65.625 60C67.875 60 70.0781 60.1875 72.2344 60.5625C74.3906 60.9375 76.5625 61.5 78.75 62.25V17.25C79.6875 17.5625 80.6094 17.8906 81.5156 18.2344C82.4219 18.5781 83.3125 19 84.1875 19.5C84.875 19.8125 85.3906 20.2813 85.7344 20.9063C86.0781 21.5313 86.25 22.1875 86.25 22.875V68.0625C86.25 69.5 85.6406 70.5938 84.4219 71.3438C83.2031 72.0938 81.9375 72.125 80.625 71.4375C78.3125 70.1875 75.8906 69.2188 73.3594 68.5312C70.8281 67.8438 68.25 67.5 65.625 67.5C61.875 67.5 58.25 68.1562 54.75 69.4688C51.25 70.7812 48 72.625 45 75ZM52.5 56.25V20.625L71.25 1.875V39.375L52.5 56.25ZM37.5 62.3438V25.2188C35.4375 24.3438 33.2969 23.6719 31.0781 23.2031C28.8594 22.7344 26.625 22.5 24.375 22.5C22.0625 22.5 19.8125 22.7188 17.625 23.1562C15.4375 23.5938 13.3125 24.25 11.25 25.125V62.3438C13.4375 61.5312 15.6094 60.9375 17.7656 60.5625C19.9219 60.1875 22.125 60 24.375 60C26.625 60 28.8281 60.1875 30.9844 60.5625C33.1406 60.9375 35.3125 61.5312 37.5 62.3438Z",
    fill: "#000A8C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBook);
export default __webpack_public_path__ + "static/media/icon-book.9cfb842c.svg";
export { ForwardRef as ReactComponent };